import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import Footer from "../components/Footer";
import Header from "../components/Header";
import PartnersSlider from "../components/PartnerSlider";


export default function Partnership() 
{

  const info = [
    { title: "Instituts de recherche", desc: "Agrospace valorise la recherche scientifique en collaborant avec les instituts spécialisés. Leurs travaux sont intégrés dans notre corpus de données afin d’offrir aux acteurs agricoles des informations fiables et actualisées.", icon: "bi bi-check-circle-fill" },
    { title: "Universités", desc: "Nous travaillons aux côtés des universités pour capitaliser sur la formation et l’innovation. Les projets académiques et résultats d’études viennent enrichir notre plateforme afin de diffuser le savoir auprès de la communauté agricole.", icon: "bi bi-check-circle-fill" },
    { title: "Instituts gouvernementales", desc: "Agrospace coopère avec les institutions gouvernementales pour centraliser les directives, réglementations et programmes officiels. Ces données renforcent la pertinence de notre plateforme et soutiennent une agriculture plus organisée et durable.", icon: "bi bi-check-circle-fill" },
  ];

  const partners = [
    
    { title: "USSEIN", desc: "Université Sine Saloum El-Hadj Ibrahima NIASS", icon: "../img/ussein-img.png" },
    { title: "ISRA", desc: "Institut Sénégalais de Recherches Agricoles", icon: "../img/isra-img.png" },
    { title: "SAED", desc: "Société nationale D'Aménagement et d'Exploitation des Terres du Delta de Fleuve Sénégal", icon: "../img/saed-img.png" },
    { title: "UGB", desc: "Université Gaston Berger de Saint-Louis", icon: "../img/ugb-img.png" },
    { title: "INP", desc: "Institut National de Pédologie", icon: "../favicon.png" },
    { title: "ANAT", desc: "Agence nationale de l'Aménagement du territoire.", icon: "../favicon.png" },
    { title: "ANSD", desc: "Agence Nationale de la Statistique et de la Démographie", icon: "../img/ansd-img.png" },
    { title: "ANACIM", desc: "Agence Nationale de l'Aviation Civile et de la Météorologie", icon: "../favicon.png" },
    { title: "ENSA", desc: "École Nationale Supérieure d'Agriculture ", icon: "../favicon.png" },
  ];

  return (
    <div className="bg-light min-vh-100">
      {/* Header's section */}
      <Header page={5} />

      <div className="container pt-4">
        <div className="row justify-content-center">
          <div className="col-md-7">
            <div className="d-flex flex-column gap-3 text-center py-5 mt-5">
              <h1 className="" >Nos partenariats stratégiques permettent de centraliser l’information et de soutenir l’innovation dans le secteur agricole.</h1>
              <p className="text-muted"> En collaborant avec les acteurs académiques et institutionnels, Agrospace transforme la recherche en solutions concrètes pour l’agriculture. </p>
              <div className="d-flex justify-content-center jus mt-3">
                <a className="btn btn-lg btn-outline-dark d-flex align-items-center" href="/contact">
                 Contactez-nous <i className="bi bi-arrow-right ms-2"></i>
                </a>
              </div>
            </div>
          </div>
        </div>   
      </div>

      {/* Popular Pages */}
      <div className="container pb-5 pt-4">
        <div className="row g-4 pb-5">
          {info.map((item, idx) => (
            <div className="col-md-4" key={idx}>
              <div className="d-flex flex-column mb-3 border rounded-2 p-4">
                <div className="fs-4 text-success me-2">
                  <i className={item.icon}></i>
                </div>
                <h4>{item.title}</h4>
                <p>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Second section */}
      <div className="container-fluid bg-green-light text-light d-flex justify-content-center align-items-center py-5" >
        <div className="row justify-content-center px-2 py-5">
          {/* Text content on top*/}
          <div className="col-lg-7 text-center mb-4 mb-lg-0 py-4 border">
            <p className="text-dark h1 fw-bold mb-3"> Plateforme Agrospace </p>
            <p className="lead text-muted mx-auto">
              Agrospace s’engage à créer des partenariats solides avec les acteurs clés du secteur agricole et académique, afin de valoriser la recherche, partager le savoir et centraliser les informations utiles pour une agriculture plus innovante et efficace.
            </p>
          </div>
        </div>
      </div>
      {/* Second section */}
      <div className="container-fluid bg-green-light pb-5" >
         <PartnersSlider partners={partners} />
      </div>

      {/* Footer's section */}
      <Footer />
      
    </div>
  );
}
